import { vodContentFetchItemByIdSelector } from 'app-webtech-core/modules/vodContent/selectors/fetchItemById';

const mapVodContentToInfoBanner = (id, getState) => {
  const { name, type, duration } = vodContentFetchItemByIdSelector(getState())(id);

  return {
    vodContent: {
      name,
      type,
      duration,
    },
  };
};

export default mapVodContentToInfoBanner;
